import {ReactNode} from 'react';
import {view, css} from '@sail/ui/deprecated';
import {useTheme} from '../ThemeProvider';

type Props = {
  children: ReactNode;
  hover?: boolean;
};

const cardStyles = css({
  backgroundColor: 'surface',
  borderRadius: 'xsmall',
  boxShadow: 'base',
  padding: css.value('$space.200'),
  marginBottom: 'small',
});

const hoverStyles = css({
  '&:hover': {
    boxShadow: 'hover',
  },
});

export function Card({children, hover}: Props) {
  const theme = useTheme();

  const styles = [cardStyles];
  if (hover) {
    styles.push(hoverStyles);
  }

  return (
    <view.div
      data-testid="card"
      uses={styles}
      css={{
        '&:focus': {
          outline: theme.focusVisibleOutline,
          focusRing: theme.focusVisibleOutline ? css.value('none') : undefined,
        },
      }}
    >
      {children}
    </view.div>
  );
}
